/* Регистрация service worker'а — нужен для push-уведомлений.
   Никакого офлайн-кеша (в отличие от стандартного CRA-шаблона): приложение
   всегда должно ходить в API за свежими данными. */

export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        console.error('Не удалось зарегистрировать service worker:', error);
      });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}
